import(/* webpackMode: "eager" */ "/vercel/path0/src/app/announcements/page.tsx");
